import { takeLatest, put } from 'redux-saga/effects'
import NProgress from 'nprogress'

import * as CONST from 'Reducers/Users/const'
import * as ERRORS from 'Reducers/Errors/const'

import { authorization } from 'Module/Auth/Auth'
import { apiClient } from 'Module/API/Client'
import { callApi } from 'Reducers/apiCall'
import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'

/**
 * Get users
 */
function* getUsers() {
  NProgress.start()

  try {
    const response = yield callApi(apiClient.getUsers)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_USERS_SUCCESS,
        payload: {
          users: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}

  NProgress.done()
}

/**
 * Get user by id
 */
function* getUserById(action) {
  try {
    yield put(decBlockCounter())

    const response = yield callApi(apiClient.getUserById, action.userId)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.GET_USER_BY_ID_SUCCESS,
        payload: {
          userById: responseJson,
        },
      })
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}
}

/**
 * Create user
 */
function* createUser(action) {
  const { callbacks, payload } = action

  NProgress.start()
  yield put(incUIBlockCounter())

  try {
    const response = yield callApi(apiClient.createUser, payload)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.CREATE_USER_SUCCESS,
        payload: {
          clientView: responseJson,
        },
      })
      callbacks.onSuccess && callbacks.onSuccess(responseJson)
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}
  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Update user by id
 */
function* updateUserById(action) {
  const { callbacks, payload, userId } = action

  NProgress.start()
  yield put(incUIBlockCounter())
  try {
    const response = yield callApi(apiClient.updateUserById, userId, payload)
    const responseJson = yield response.json()

    if (response.ok) {
      yield put({
        type: CONST.UPDATE_USER_BY_ID_SUCCESS,
        payload: {
          clientView: responseJson,
        },
      })

      if (authorization.getUser().id === responseJson.id) {
        authorization.updateUser(responseJson)
      }

      callbacks && callbacks.onSuccess()
    } else {
      yield put({
        type: ERRORS.PUSH_API_ERROR,
        error: responseJson,
      })
    }
  } catch (ex) {}
  yield put(decBlockCounter())
  NProgress.done()
}

/**
 * Get users request watcher
 */
export function* watchGetUsers() {
  yield takeLatest(CONST.GET_USERS, getUsers)
}

/**
 * Get user by id request watcher
 */
export function* watchGetUserById() {
  yield takeLatest(CONST.GET_USER_BY_ID, getUserById)
}

/**
 * Create users request watcher
 */
export function* watchCreateUser() {
  yield takeLatest(CONST.CREATE_USER, createUser)
}

/**
 * Update user by id request watcher
 */
export function* watchUpdateUserById() {
  yield takeLatest(CONST.UPDATE_USER_BY_ID, updateUserById)
}



// WEBPACK FOOTER //
// ./src/Reducers/Users/sagas.js